import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const approvedBanks = [
  { name: 'Sonali Bank Ltd.', accounts: 128, status: 'Active Partner', type: 'State-owned' },
  { name: 'Dutch-Bangla Bank Ltd.', accounts: 94, status: 'Active Partner', type: 'Private' },
  { name: 'BRAC Bank Ltd.', accounts: 87, status: 'Active Partner', type: 'Private' },
  { name: 'Islami Bank Bangladesh', accounts: 112, status: 'Active Partner', type: 'Islamic' },
  { name: 'Eastern Bank Ltd.', accounts: 76, status: 'Active Partner', type: 'Private' },
  { name: 'Pubali Bank Ltd.', accounts: 65, status: 'Active Partner', type: 'Private' }
];

const BuildingApprovalStatus = () => {
  const [permitNo, setPermitNo] = useState('');
  const [verified, setVerified] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleVerify = () => {
    if (!permitNo?.trim()) return;
    setLoading(true);
    setTimeout(() => {
      setVerified({
        permitNumber: permitNo,
        bank: 'Dutch-Bangla Bank Ltd.',
        projectName: 'Bashundhara Residential Complex',
        developer: 'Bashundhara Group',
        totalFunds: '৳ 18,50,00,000',
        releasedFunds: '৳ 6,20,00,000',
        heldFunds: '৳ 12,30,00,000',
        rajukApproved: true,
        lastAudit: '2025-01-20',
        nextAudit: '2025-04-20',
        buildingPermit: 'BP-DHA-2024-00123',
        floorAreaRatio: '3.5 FAR',
        approvedFloors: '12 Floors'
      });
      setLoading(false);
    }, 1200);
  };

  return (
    <div className="rounded-2xl p-6" style={{ background: 'rgba(10,22,40,0.9)', border: '1px solid rgba(0,180,80,0.2)' }}>
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-xl flex items-center justify-center" style={{ background: 'rgba(0,180,80,0.1)', border: '1px solid rgba(0,180,80,0.3)' }}>
          <Icon name="FileCheck" size={20} color="#00B450" />
        </div>
        <div>
          <h3 className="text-lg font-bold" style={{ color: '#E8F4FF' }}>Building Approval Status</h3>
          <p className="text-xs" style={{ color: '#6B9EC4' }}>Verify building permits, FAR compliance & RAJUK-approved construction plans</p>
        </div>
      </div>
      <div className="flex flex-col sm:flex-row gap-3 mb-6">
        <input
          type="text"
          value={permitNo}
          onChange={e => setPermitNo(e?.target?.value)}
          placeholder="Enter building permit number (e.g. BP-DHA-2024-00123)"
          className="flex-1 px-4 py-3 rounded-xl text-sm outline-none"
          style={{ background: 'rgba(0,180,80,0.05)', border: '1px solid rgba(0,180,80,0.2)', color: '#E8F4FF' }}
        />
        <button
          onClick={handleVerify}
          disabled={loading}
          className="px-5 py-3 rounded-xl font-semibold text-sm"
          style={{ background: '#00B450', color: '#FFFFFF' }}
        >
          {loading ? 'Checking...' : 'Check Permit'}
        </button>
      </div>
      {verified && (
        <div className="rounded-xl p-4 mb-6" style={{ background: 'rgba(34,197,94,0.08)', border: '1px solid rgba(34,197,94,0.25)' }}>
          <div className="flex items-center gap-2 mb-4">
            <Icon name="CheckCircle" size={18} color="#22c55e" />
            <span className="font-semibold text-sm" style={{ color: '#22c55e' }}>Building Permit Verified</span>
          </div>
          <div className="grid grid-cols-2 gap-3">
            {[
              { label: 'Bank', value: verified?.bank },
              { label: 'Project', value: verified?.projectName },
              { label: 'Developer', value: verified?.developer },
              { label: 'RAJUK Approved', value: verified?.rajukApproved ? '✓ Yes' : '✗ No' },
              { label: 'Building Permit', value: verified?.buildingPermit },
              { label: 'Floor Area Ratio', value: verified?.floorAreaRatio },
              { label: 'Approved Floors', value: verified?.approvedFloors },
              { label: 'Last Audit', value: verified?.lastAudit },
              { label: 'Total Project Funds', value: verified?.totalFunds },
              { label: 'Held Funds', value: verified?.heldFunds }
            ]?.map((item, i) => (
              <div key={i} className="p-2 rounded-lg" style={{ background: 'rgba(10,22,40,0.6)' }}>
                <div className="text-xs" style={{ color: '#6B9EC4' }}>{item?.label}</div>
                <div className="text-sm font-medium" style={{ color: '#E8F4FF' }}>{item?.value}</div>
              </div>
            ))}
          </div>
        </div>
      )}
      <div>
        <h4 className="text-sm font-semibold mb-3" style={{ color: '#E8F4FF' }}>RAJUK-Approved Financing Banks</h4>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {approvedBanks?.map((bank, i) => (
            <div key={i} className="flex items-center gap-3 p-3 rounded-xl" style={{ background: 'rgba(0,180,80,0.05)', border: '1px solid rgba(0,180,80,0.12)' }}>
              <span className="text-xl">🏦</span>
              <div className="flex-1 min-w-0">
                <div className="text-sm font-medium truncate" style={{ color: '#E8F4FF' }}>{bank?.name}</div>
                <div className="text-xs" style={{ color: '#6B9EC4' }}>{bank?.accounts} active accounts · {bank?.type}</div>
              </div>
              <span className="text-xs px-2 py-0.5 rounded-full" style={{ background: 'rgba(34,197,94,0.1)', color: '#22c55e' }}>Active</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BuildingApprovalStatus;
